import {TemplateList} from "~/libs/constants/TemplateList"
import {NewsletterConfig} from "~/config/NewsletterConfig"
import type NewsletterLocal from "~/libs/interfaces/NewsletterLocal"

export const useNewsletterConfig = () => {
  const getNewsletterList = (): NewsletterLocal[] => {

    const smartEmailing = useRuntimeConfig().public.smartEmailing
    if (!smartEmailing.enabled) {
      return []
    }

    const allowedContactListIds = smartEmailing.allowedContactListIds ? smartEmailing.allowedContactListIds.split(',').map(String) : []

    type TemplateListKeys = keyof typeof TemplateList;
    const uniWebTemplateName:TemplateListKeys | undefined = useRuntimeConfig().public.uniWebTemplateName ? String(useRuntimeConfig().public.uniWebTemplateName).toUpperCase() as TemplateListKeys : undefined
    if (uniWebTemplateName && (uniWebTemplateName in TemplateList)) {
      return NewsletterConfig[TemplateList[uniWebTemplateName]].filter((config) => {
        return allowedContactListIds.includes(String(config.contactListId))
      })
    }
    return []
  }


  const getNewsletterByContactListId = (id: string): NewsletterLocal | undefined => {
    const newsletterList = getNewsletterList()
    return newsletterList.find(newsletter => {
      return String(newsletter.contactListId) === String(id)
    })
  }

  const getNewsletterBySecondaryContactListId = (id: string): NewsletterLocal | undefined => {
    const newsletterList = getNewsletterList()
    return newsletterList.find(newsletter => {
      return newsletter.secondaryContactListId && String(newsletter.secondaryContactListId) === String(id)
    })
  }

  return {
    getNewsletterList,
    getNewsletterByContactListId
  }
}


